import "./list.css"

import React from "react"
import {styled} from "@mui/material/styles"

import {EntityListItems} from "../../components/List";
import {BaseInlineListHeadlineLayout, BaseListItemLayout} from "../base/ListItemLayout";

const PREFIX = "List"

export const classes = {
  listItem: `${PREFIX}-listItem`,
  listLink: `${PREFIX}-listLink`,
  listImg: `${PREFIX}-listImg`,
  titleDiv: `${PREFIX}-titleDiv`,
  titleFlex: `${PREFIX}-titleFlex`,
  title1: `${PREFIX}-title1`,
  title2: `${PREFIX}-title2`,
  title3: `${PREFIX}-title3`,
  numCode: `${PREFIX}-numCode`,
  playButton: `${PREFIX}-playButton`,
  associatedEntity: `${PREFIX}-associatedEntity`,
  associatedLinkIcon: `${PREFIX}-associatedLinkIcon`,
  associatedLinkText: `${PREFIX}-associatedLinkIcon`,
}

export const Root = styled("ul")(({ theme }) => ({
  listStyleType: "none",
  margin: "0",
  marginTop:"10px",
  padding: 0,

  [`& .${classes.listItem}`]: {
    textDecoration: "none",
    padding: "0",
    color: theme.palette.primary.main,
    background: theme.palette.mode === "light" ? "#ffffff" : "#333",
    borderBottom: '1px solid',
    borderColor: theme.palette.mode === "light" ? "#ddd" : "#737373",
    listStyle: "none",
    display: "flex",
    flexDirection:"row",
    justifyContent: "flex-start",
    minHeight: "48px",
    margin: "0",
    overflow: "hidden",
    alignItems: "center",
  },

  [`& .${classes.listLink}`]: {
    textDecoration: "none"
  },

  [`& .${classes.listImg}:not(.hero)`]: {
    width: "100px",
    height: "100px",
  },

  [`& .${classes.titleDiv}`]: {
    width: "100%",
    overflow: "hidden",
    padding: "0px 28px 0px 11px"
  },

  [`& .${classes.titleFlex}`]: {
    display: "flex",
    flexGrow: "1",
    alignItems: "center",
    position: "relative",
    minHeight: "60px",
  },

  [`& .${classes.title1}`]: {
    fontSize: '1rem',
    textTransform: 'none',
    marginBottom: 0,
    lineHeight: 1.15,
    fontWeight: 700,
  },

  [`& .${classes.title2}`]: {
    fontSize: 'var(--font-size-large)',
    lineHeight: 1.2,
    marginTop: 4,
    paddingRight: 20,
  },

  [`& .${classes.title3}`]: {
    fontSize: "1rem",
    marginBottom: "0px",
    marginTop: "2px",
    fontWeight: "normal"
  },

  [`& .${classes.numCode}`]: {
    position: "absolute",
    right: "10px",
    bottom: "7px",
    fontSize: "0.9rem",
    fontWeight: "bold",
    display:"none"
  },

  [`& .${classes.playButton}`]: {
    position: "absolute",
    right: "6px",
    top: "50%",
    transform: "translateY(-50%)"
  },

  [`& .${classes.associatedEntity}`]: {
    display: "block",
    position: "absolute",
    right: "6px",
    bottom: "6px",
    fontSize: "1rem",
  },

  [`& .${classes.associatedEntity} a`]: {
    textDecoration: "none",
    color: theme.palette.primary.main,
  },

  [`& .${classes.associatedLinkIcon}`]: {
  },

  [`& .${classes.associatedLinkText}`]: {
  },
}))

const WmaListItemLayout = (props) => {
    return <BaseListItemLayout {...props} classes={classes} />
}

const WmaInlineListHeadlineLayout = ({ entity, listRole }) => {
  return (
      <BaseInlineListHeadlineLayout entity={entity} listRole={listRole} classes={classes} />
  )
}

const WmaList = ({ entity, pageContext, config }) => {
  const listType = config?.listType || 'standard'

  return (
      <Root className={"list-type-" + listType}>
          <EntityListItems entity={entity} pageContext={pageContext} config={config} listItemLayout={WmaListItemLayout} inlineListHeadlineLayout={WmaInlineListHeadlineLayout} />
      </Root>
  );
};

export default WmaList
